import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invite-code",
  "use": "icon-invite-code-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-invite-code\"><rect x=\"2\" y=\"4\" width=\"20\" height=\"16\" rx=\"2\" /><line x1=\"6\" y1=\"10\" x2=\"6\" y2=\"10\" /><line x1=\"10\" y1=\"10\" x2=\"10\" y2=\"10\" /><line x1=\"14\" y1=\"10\" x2=\"18\" y2=\"10\" /><line x1=\"6\" y1=\"14\" x2=\"18\" y2=\"14\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol